import React from "react";
import MUISkeleton, { SkeletonProps } from "@mui/material/Skeleton";

type Props = SkeletonProps & {
    opacity?: string;
    sx?: Record<string, unknown>;
};

const Skeleton = ({ opacity = "0.5", sx, ...props }: Props) => (
    <MUISkeleton
        animation="wave"
        sx={{
            bgcolor: `rgb(240,240,240,${opacity})`,
            transform: "scale(1)",
            ...sx,
        }}
        {...props}
    />
);
export default Skeleton;

// note: MUI 5.8 doesn't have variant="rounded" yet
export const RoundedSkeleton = (props: Props) => <Skeleton variant="rectangular" {...props} />;
